import { ModalWrapper, ModalBody, ModalFooter, ModalSecondaryButton } from '@zooplus/ui-components';

import { useTranslation } from '@hooks/use-translations';
import { HTMLParser } from '@utilities/html-parser';

type CouponsInfoModalProps = {
  modalBody?: string;
  isModalOpen: boolean;
  callback: Function;
};

const CouponsInfoModal = ({ modalBody, isModalOpen, callback }: CouponsInfoModalProps) => {
  const { t } = useTranslation();

  return (
    <ModalWrapper
      isOpen={isModalOpen}
      onClose={() => callback(false)}
      closeBtnAriaLabel={t('cart.button.close')}
      heading={`${t('loy.coupons.component.title')} / ${t(
        'loy.coupons.component.surcharge.title',
      )}`}
      headingId={'couponsInfoModal'}>
      <ModalBody>
        <HTMLParser content={modalBody} />
      </ModalBody>
      <ModalFooter>
        <ModalSecondaryButton onClick={() => callback(false)}>
          {t('cart.button.close')}
        </ModalSecondaryButton>
      </ModalFooter>
    </ModalWrapper>
  );
};

export default CouponsInfoModal;
